export const hotProducts = [
  {
    id: 1,
    name: "Apple iPhone 15 Pro Max 256GB 钛金属",
    price: 9999,
    originalPrice: 11999,
    image: "https://public.readdy.ai/ai/img_res/084ae8a0be2a2dc5c4135433711f1270.jpg",
    category: "手机数码",
    sales: 12580,
    rating: 4.9,
    tag: "爆款",
  },
  {
    id: 2,
    name: "华为 Mate 60 Pro 旗舰手机 512GB",
    price: 6999,
    originalPrice: 7999,
    image: "https://readdy.ai/api/search-image?query=Huawei%20Mate%2060%20Pro%20flagship%20smartphone%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting&width=400&height=400&seq=prod2&orientation=squarish",
    category: "手机数码",
    sales: 9870,
    rating: 4.8,
    tag: "新品",
  },
  {
    id: 3,
    name: "戴森 V15 Detect 无线吸尘器",
    price: 4490,
    originalPrice: 5290,
    image: "https://readdy.ai/api/search-image?query=Dyson%20V15%20Detect%20cordless%20vacuum%20cleaner%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting&width=400&height=400&seq=prod3&orientation=squarish",
    category: "家用电器",
    sales: 5430,
    rating: 4.7,
    tag: "热销",
  },
  {
    id: 4,
    name: "SK-II 神仙水精华液 230ml 礼盒装",
    price: 1580,
    originalPrice: 1980,
    image: "https://readdy.ai/api/search-image?query=SK-II%20Facial%20Treatment%20Essence%20luxury%20skincare%20bottle%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting&width=400&height=400&seq=prod4&orientation=squarish",
    category: "美妆护肤",
    sales: 23100,
    rating: 4.9,
    tag: "礼盒",
  },
  {
    id: 5,
    name: "耐克 Air Jordan 1 Retro High OG",
    price: 1299,
    originalPrice: 1599,
    image: "https://readdy.ai/api/search-image?query=Nike%20Air%20Jordan%201%20Retro%20High%20OG%20sneakers%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting&width=400&height=400&seq=prod5&orientation=squarish",
    category: "运动户外",
    sales: 8760,
    rating: 4.8,
    tag: "限量",
  },
  {
    id: 6,
    name: "小米 14 Ultra 徕卡影像旗舰",
    price: 5999,
    originalPrice: 6999,
    image: "https://readdy.ai/api/search-image?query=Xiaomi%2014%20Ultra%20Leica%20camera%20smartphone%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting&width=400&height=400&seq=prod6&orientation=squarish",
    category: "手机数码",
    sales: 7650,
    rating: 4.8,
    tag: "新品",
  },
  {
    id: 7,
    name: "松下 LUMIX S5II 全画幅微单相机",
    price: 12800,
    originalPrice: 14800,
    image: "https://readdy.ai/api/search-image?query=Panasonic%20Lumix%20S5II%20full%20frame%20mirrorless%20camera%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting&width=400&height=400&seq=prod7&orientation=squarish",
    category: "摄影摄像",
    sales: 3210,
    rating: 4.9,
    tag: "专业",
  },
  {
    id: 8,
    name: "爱马仕 Birkin 30 经典手提包",
    price: 89000,
    originalPrice: 95000,
    image: "https://readdy.ai/api/search-image?query=Hermes%20Birkin%2030%20luxury%20handbag%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting&width=400&height=400&seq=prod8&orientation=squarish",
    category: "奢侈品",
    sales: 890,
    rating: 5.0,
    tag: "奢品",
  },
  {
    id: 9,
    name: "电动高尔夫球车 四座豪华版",
    price: 28800,
    originalPrice: 35000,
    image: "https://readdy.ai/api/search-image?query=electric%20golf%20cart%20four%20seater%20luxury%20model%20shiny%20white%20body%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting%2C%20elegant%20outdoor%20vehicle%20design&width=400&height=400&seq=prod9&orientation=squarish",
    category: "运动户外",
    sales: 1230,
    rating: 4.8,
    tag: "热销",
  },
  {
    id: 10,
    name: "数码相框 10英寸 WiFi云相册",
    price: 399,
    originalPrice: 599,
    image: "https://readdy.ai/api/search-image?query=digital%20photo%20frame%2010%20inch%20WiFi%20smart%20display%20showing%20beautiful%20family%20photos%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting%2C%20modern%20slim%20design%2C%20IPS%20screen&width=400&height=400&seq=prod10&orientation=squarish",
    category: "手机数码",
    sales: 8920,
    rating: 4.7,
    tag: "爆款",
  },
  {
    id: 11,
    name: "LG 27英寸 4K IPS 电脑显示器",
    price: 2199,
    originalPrice: 2799,
    image: "https://readdy.ai/api/search-image?query=LG%2027%20inch%204K%20IPS%20computer%20monitor%20ultra%20slim%20bezel%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting%2C%20modern%20office%20display%2C%20crisp%20screen&width=400&height=400&seq=prod11&orientation=squarish",
    category: "手机数码",
    sales: 6540,
    rating: 4.8,
    tag: "热销",
  },
  {
    id: 12,
    name: "三星 32英寸 240Hz 电竞显示器",
    price: 3299,
    originalPrice: 4199,
    image: "https://readdy.ai/api/search-image?query=Samsung%2032%20inch%20240Hz%20gaming%20monitor%20with%20RGB%20ambient%20lighting%20curved%20screen%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting%2C%20esports%20gaming%20setup%2C%20dark%20sleek%20design&width=400&height=400&seq=prod12&orientation=squarish",
    category: "手机数码",
    sales: 4870,
    rating: 4.9,
    tag: "爆款",
  },
  {
    id: 13,
    name: "粘毛滚筒 可撕式除尘滚轮 10卷装",
    price: 39,
    originalPrice: 59,
    image: "https://readdy.ai/api/search-image?query=lint%20roller%20sticky%20pick%20up%20roller%20set%2010%20refill%20rolls%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting%2C%20household%20cleaning%20tool%2C%20neat%20packaging&width=400&height=400&seq=prod13&orientation=squarish",
    category: "家用电器",
    sales: 45600,
    rating: 4.6,
    tag: "爆款",
  },
  {
    id: 14,
    name: "法式优雅碎花连衣裙 夏季新款",
    price: 299,
    originalPrice: 499,
    image: "https://readdy.ai/api/search-image?query=elegant%20French%20floral%20summer%20dress%20beautiful%20fashion%20clothing%20displayed%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting%2C%20feminine%20flowing%20fabric%2C%20pastel%20colors&width=400&height=400&seq=prod14&orientation=squarish",
    category: "服装鞋包",
    sales: 18900,
    rating: 4.8,
    tag: "新品",
  },
  {
    id: 15,
    name: "李维斯 511 修身直筒牛仔裤",
    price: 499,
    originalPrice: 699,
    image: "https://readdy.ai/api/search-image?query=Levis%20511%20slim%20fit%20straight%20jeans%20denim%20pants%20folded%20neatly%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting%2C%20classic%20indigo%20blue%20denim%20fashion&width=400&height=400&seq=prod15&orientation=squarish",
    category: "服装鞋包",
    sales: 22300,
    rating: 4.7,
    tag: "热销",
  },
  {
    id: 16,
    name: "复古渔夫帽 男女通用 防晒遮阳",
    price: 89,
    originalPrice: 139,
    image: "https://readdy.ai/api/search-image?query=vintage%20bucket%20hat%20unisex%20sun%20protection%20hat%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting%2C%20trendy%20fashion%20accessory%2C%20beige%20neutral%20color%2C%20cotton%20fabric&width=400&height=400&seq=prod16&orientation=squarish",
    category: "服装鞋包",
    sales: 31200,
    rating: 4.6,
    tag: "爆款",
  },
  {
    id: 17,
    name: "男士商务休闲西装套装 修身版",
    price: 899,
    originalPrice: 1299,
    image: "https://readdy.ai/api/search-image?query=mens%20business%20casual%20slim%20fit%20suit%20set%20blazer%20and%20trousers%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting%2C%20elegant%20menswear%20fashion%2C%20charcoal%20grey%20color&width=400&height=400&seq=prod17&orientation=squarish",
    category: "服装鞋包",
    sales: 9870,
    rating: 4.8,
    tag: "热销",
  },
  {
    id: 18,
    name: "羊绒混纺圆领毛衣 男女同款",
    price: 359,
    originalPrice: 599,
    image: "https://readdy.ai/api/search-image?query=cashmere%20blend%20crew%20neck%20sweater%20pullover%20knitwear%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting%2C%20soft%20cozy%20texture%2C%20warm%20beige%20cream%20color%2C%20unisex%20fashion&width=400&height=400&seq=prod18&orientation=squarish",
    category: "服装鞋包",
    sales: 14500,
    rating: 4.7,
    tag: "新品",
  },
  {
    id: 19,
    name: "北欧风实木餐桌椅组合 6人座",
    price: 4999,
    originalPrice: 7200,
    image: "https://readdy.ai/api/search-image?query=Nordic%20Scandinavian%20solid%20oak%20wood%20dining%20table%20and%20chairs%20set%206%20seats%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting%2C%20natural%20wood%20grain%20texture%2C%20modern%20furniture%20design&width=400&height=400&seq=prod19&orientation=squarish",
    category: "家居家具",
    sales: 3450,
    rating: 4.9,
    tag: "热销",
  },
  {
    id: 20,
    name: "全身落地镜 金属细框 180×60cm",
    price: 599,
    originalPrice: 899,
    image: "https://readdy.ai/api/search-image?query=full%20length%20floor%20standing%20mirror%20thin%20gold%20metal%20frame%20180x60cm%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting%2C%20modern%20home%20decor%2C%20elegant%20interior%20design&width=400&height=400&seq=prod20&orientation=squarish",
    category: "家居家具",
    sales: 19800,
    rating: 4.8,
    tag: "爆款",
  },
  {
    id: 21,
    name: "乐高 42154 福特 GT 跑车积木",
    price: 1299,
    originalPrice: 1599,
    image: "https://readdy.ai/api/search-image?query=LEGO%20Technic%20Ford%20GT%20sports%20car%20building%20blocks%20toy%20set%20assembled%20model%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting%2C%20colorful%20plastic%20bricks%2C%20red%20sports%20car&width=400&height=400&seq=prod21&orientation=squarish",
    category: "母婴玩具",
    sales: 7620,
    rating: 4.9,
    tag: "爆款",
  },
];

export const categories = [
  { id: 1, name: "手机数码", icon: "ri-smartphone-line", color: "bg-red-50", iconColor: "text-red-500", image: "https://readdy.ai/api/search-image?query=modern%20smartphones%20and%20digital%20devices%20collection%20on%20soft%20gradient%20background%2C%20clean%20minimal%20product%20photography&width=120&height=120&seq=cat1&orientation=squarish" },
  { id: 2, name: "家用电器", icon: "ri-tv-line", color: "bg-orange-50", iconColor: "text-orange-500", image: "https://readdy.ai/api/search-image?query=home%20appliances%20collection%20washing%20machine%20refrigerator%20on%20soft%20gradient%20background%2C%20clean%20minimal%20product%20photography&width=120&height=120&seq=cat2&orientation=squarish" },
  { id: 3, name: "美妆护肤", icon: "ri-heart-line", color: "bg-pink-50", iconColor: "text-pink-500", image: "https://readdy.ai/api/search-image?query=luxury%20beauty%20skincare%20cosmetics%20collection%20on%20soft%20pink%20gradient%20background%2C%20clean%20minimal%20product%20photography&width=120&height=120&seq=cat3&orientation=squarish" },
  { id: 4, name: "服装鞋包", icon: "ri-t-shirt-line", color: "bg-purple-50", iconColor: "text-purple-500", image: "https://readdy.ai/api/search-image?query=fashion%20clothing%20shoes%20bags%20collection%20on%20soft%20gradient%20background%2C%20clean%20minimal%20product%20photography&width=120&height=120&seq=cat4&orientation=squarish" },
  { id: 5, name: "运动户外", icon: "ri-run-line", color: "bg-green-50", iconColor: "text-green-500", image: "https://readdy.ai/api/search-image?query=sports%20outdoor%20equipment%20running%20shoes%20fitness%20gear%20on%20soft%20gradient%20background%2C%20clean%20minimal%20product%20photography&width=120&height=120&seq=cat5&orientation=squarish" },
  { id: 6, name: "食品生鲜", icon: "ri-restaurant-line", color: "bg-yellow-50", iconColor: "text-yellow-600", image: "https://readdy.ai/api/search-image?query=fresh%20food%20fruits%20vegetables%20gourmet%20products%20on%20soft%20gradient%20background%2C%20clean%20minimal%20product%20photography&width=120&height=120&seq=cat6&orientation=squarish" },
  { id: 7, name: "图书文具", icon: "ri-book-line", color: "bg-blue-50", iconColor: "text-blue-500", image: "https://readdy.ai/api/search-image?query=books%20stationery%20office%20supplies%20collection%20on%20soft%20gradient%20background%2C%20clean%20minimal%20product%20photography&width=120&height=120&seq=cat7&orientation=squarish" },
  { id: 8, name: "母婴玩具", icon: "ri-bear-smile-line", color: "bg-teal-50", iconColor: "text-teal-500", image: "https://readdy.ai/api/search-image?query=baby%20toys%20mother%20infant%20products%20collection%20on%20soft%20gradient%20background%2C%20clean%20minimal%20product%20photography&width=120&height=120&seq=cat8&orientation=squarish" },
  { id: 9, name: "汽车用品", icon: "ri-car-line", color: "bg-slate-50", iconColor: "text-slate-500", image: "https://readdy.ai/api/search-image?query=car%20accessories%20automotive%20products%20collection%20on%20soft%20gradient%20background%2C%20clean%20minimal%20product%20photography&width=120&height=120&seq=cat9&orientation=squarish" },
  { id: 10, name: "奢侈品", icon: "ri-vip-crown-line", color: "bg-amber-50", iconColor: "text-amber-600", image: "https://readdy.ai/api/search-image?query=luxury%20goods%20watches%20jewelry%20handbags%20collection%20on%20soft%20gradient%20background%2C%20clean%20minimal%20product%20photography&width=120&height=120&seq=cat10&orientation=squarish" },
  { id: 11, name: "服装鞋包", icon: "ri-t-shirt-line", color: "bg-rose-50", iconColor: "text-rose-500", image: "https://readdy.ai/api/search-image?query=fashion%20clothing%20dress%20jeans%20hat%20sweater%20collection%20on%20soft%20gradient%20background%2C%20clean%20minimal%20product%20photography&width=120&height=120&seq=cat11&orientation=squarish" },
  { id: 12, name: "家居家具", icon: "ri-home-4-line", color: "bg-amber-50", iconColor: "text-amber-700", image: "https://readdy.ai/api/search-image?query=modern%20furniture%20home%20decor%20mirror%20table%20chair%20collection%20on%20soft%20gradient%20background%2C%20clean%20minimal%20product%20photography&width=120&height=120&seq=cat12&orientation=squarish" },
];

export const influencers = [
  {
    id: 1,
    name: "口红小王子",
    title: "美妆一哥 · 护肤达人",
    avatar: "https://readdy.ai/api/search-image?query=young%20Chinese%20male%20beauty%20influencer%20smiling%20portrait%2C%20professional%20studio%20lighting%2C%20clean%20white%20background%2C%20confident%20expression%2C%20stylish%20makeup%20artist%20vibe&width=200&height=200&seq=inf1&orientation=squarish",
    followers: "7200万",
    specialty: "美妆护肤",
    sales: "月销 3.2亿",
    badge: "超级主播",
    products: ["SK-II神仙水", "兰蔻小黑瓶", "雅诗兰黛精华"],
  },
  {
    id: 2,
    name: "全能带货姐",
    title: "全品类女王 · 爆款制造机",
    avatar: "https://readdy.ai/api/search-image?query=young%20Chinese%20female%20influencer%20smiling%20portrait%2C%20professional%20studio%20lighting%2C%20clean%20white%20background%2C%20confident%20expression%2C%20fashionable%20charismatic%20personality&width=200&height=200&seq=inf2&orientation=squarish",
    followers: "8500万",
    specialty: "全品类",
    sales: "月销 5.1亿",
    badge: "带货女王",
    products: ["iPhone 15", "戴森吸尘器", "爱马仕包包"],
  },
  {
    id: 3,
    name: "数码老铁",
    title: "科技数码 · 直播带货老司机",
    avatar: "https://readdy.ai/api/search-image?query=middle%20aged%20Chinese%20male%20tech%20influencer%20smiling%20portrait%2C%20professional%20studio%20lighting%2C%20clean%20white%20background%2C%20confident%20expression%2C%20glasses%20intellectual%20look&width=200&height=200&seq=inf3&orientation=squarish",
    followers: "4100万",
    specialty: "数码科技",
    sales: "月销 1.8亿",
    badge: "科技达人",
    products: ["华为Mate60", "小米14", "DJI无人机"],
  },
  {
    id: 4,
    name: "潮流小仙女",
    title: "时尚穿搭 · 潮流引领者",
    avatar: "https://readdy.ai/api/search-image?query=young%20Chinese%20female%20fashion%20influencer%20smiling%20portrait%2C%20professional%20studio%20lighting%2C%20clean%20white%20background%2C%20stylish%20fashionable%20expression%2C%20trendy%20outfit&width=200&height=200&seq=inf4&orientation=squarish",
    followers: "3600万",
    specialty: "服装时尚",
    sales: "月销 2.4亿",
    badge: "时尚博主",
    products: ["耐克Air Jordan", "古驰包包", "Zara新款"],
  },
];

export const distributors = [
  {
    id: 1,
    name: "皇冠优选分销商",
    region: "华东区",
    level: "钻石级",
    commission: "15%",
    members: "12,800",
    icon: "ri-vip-diamond-line",
    color: "from-cyan-400 to-blue-500",
  },
  {
    id: 2,
    name: "皇冠精品分销商",
    region: "华南区",
    level: "黄金级",
    commission: "12%",
    members: "8,500",
    icon: "ri-medal-line",
    color: "from-yellow-400 to-amber-500",
  },
  {
    id: 3,
    name: "皇冠新锐分销商",
    region: "华北区",
    level: "白银级",
    commission: "10%",
    members: "5,200",
    icon: "ri-award-line",
    color: "from-slate-400 to-gray-500",
  },
];

export const bannerSlides = [
  {
    id: 1,
    title: "皇冠鸿运五一狂欢节",
    subtitle: "全场最高立减 5000 元，爆款商品限时秒杀",
    cta: "立即抢购",
    link: "/products",
    image: "https://readdy.ai/api/search-image?query=Chinese%20shopping%20festival%20grand%20sale%20celebration%20with%20golden%20crown%20luxury%20decorations%2C%20red%20and%20gold%20color%20theme%2C%20festive%20atmosphere%2C%20wide%20banner%20format%2C%20ultra%20realistic%2C%20vibrant%20colors%2C%20no%20text&width=1400&height=500&seq=banner1&orientation=landscape",
    tag: "五一狂欢",
  },
  {
    id: 2,
    title: "Crowntalk  像微信一样连接全球",
    subtitle: "与全球朋友视频通话 · 苹果 App Store 可下载 · 国内安卓手机直接安装",
    cta: "立即下载",
    link: "/crowntalk",
    image: "https://readdy.ai/api/search-image?query=luxurious%20rich%20gold%20background%20with%20glowing%20golden%20light%20rays%20shimmering%20particles%20and%20warm%20amber%20tones%2C%20opulent%20golden%20bokeh%20abstract%20texture%2C%20global%20network%20connections%20rendered%20in%20deep%20gold%2C%20premium%20cinematic%20wide%20banner%2C%20no%20text%2C%20no%20people%2C%20elegant%20royal%20golden%20atmosphere&width=1400&height=500&seq=banner_crownchat_gold3&orientation=landscape",
    tag: "全球社交",
  },
  {
    id: 3,
    title: "奢品专区 正品保障",
    subtitle: "爱马仕、LV、Gucci 等顶级奢侈品，官方授权正品",
    cta: "探索奢品",
    link: "/products",
    image: "https://readdy.ai/api/search-image?query=luxury%20fashion%20brands%20showcase%20Hermes%20Louis%20Vuitton%20Gucci%20products%20elegant%20display%2C%20gold%20and%20cream%20color%20theme%2C%20wide%20banner%20format%2C%20ultra%20realistic%2C%20no%20text&width=1400&height=500&seq=banner3&orientation=landscape",
    tag: "奢品",
  },
  {
    id: 4,
    title: "手机数码 新品首发",
    subtitle: "iPhone 15 Pro · 华为 Mate 60 · 小米 14 Ultra，旗舰新品限时优惠",
    cta: "查看新品",
    link: "/products",
    image: "https://readdy.ai/api/search-image?query=latest%20flagship%20smartphones%20collection%20arranged%20elegantly%20on%20luxurious%20rich%20gold%20background%20with%20warm%20amber%20glow%20and%20shimmering%20golden%20light%20rays%2C%20opulent%20golden%20bokeh%20particles%2C%20premium%20product%20photography%2C%20dramatic%20golden%20studio%20lighting%2C%20no%20text%2C%20wide%20banner%20format%2C%20deep%20gold%20and%20warm%20amber%20tones&width=1400&height=500&seq=banner4_phones_gold2&orientation=landscape",
    tag: "新品首发",
  },
];

export const holidayGifts = [
  {
    id: 1,
    name: "圣诞礼盒套装",
    price: 299,
    image: "https://readdy.ai/api/search-image?query=Christmas%20gift%20box%20set%20with%20red%20ribbon%20bow%20on%20white%20background%2C%20luxury%20packaging%2C%20festive%20holiday%20decoration%2C%20professional%20product%20photography&width=300&height=300&seq=gift1&orientation=squarish",
    likes: 4521,
  },
  {
    id: 2,
    name: "新年礼品茶具",
    price: 588,
    image: "https://readdy.ai/api/search-image?query=Chinese%20New%20Year%20luxury%20tea%20set%20gift%20box%20on%20white%20background%2C%20red%20gold%20packaging%2C%20festive%20decoration%2C%20professional%20product%20photography&width=300&height=300&seq=gift2&orientation=squarish",
    likes: 3890,
  },
  {
    id: 3,
    name: "情人节香水礼盒",
    price: 1280,
    image: "https://readdy.ai/api/search-image?query=Valentine%20Day%20luxury%20perfume%20gift%20set%20on%20white%20background%2C%20romantic%20pink%20packaging%2C%20rose%20decoration%2C%20professional%20product%20photography&width=300&height=300&seq=gift3&orientation=squarish",
    likes: 6102,
  },
  {
    id: 4,
    name: "母亲节护肤礼包",
    price: 899,
    image: "https://readdy.ai/api/search-image?query=Mother%20Day%20luxury%20skincare%20gift%20set%20on%20white%20background%2C%20elegant%20packaging%2C%20floral%20decoration%2C%20professional%20product%20photography&width=300&height=300&seq=gift4&orientation=squarish",
    likes: 5234,
  },
];
